import { useQuery } from '@tanstack/react-query';
import type { CustomerSystem } from '@avslack/shared';
import { ApiRequestError, getMe } from './api';
import { withOfflineFallback } from './offline-cache';

/**
 * A bejelentkezett felhasznalo.
 *
 * A `mustChangePassword` szandekosan ITT jon vissza, nem kulon lekeresben:
 * igy a felulet minden ujratoltesnel latja, hogy a kotelezo jelszovaltas
 * megvan-e - nem lehet egy oldalfrissitessel megkerulni.
 */
export function useSession() {
  return useQuery({
    queryKey: ['session'],
    // Terero nelkul az utolso ismert belepes - lasd offline-cache.ts.
    queryFn: withOfflineFallback('session', getMe),
    retry: (failureCount, error) => {
      // A 401 nem atmeneti hiba - nincs ertelme ujraprobalni.
      if (error instanceof ApiRequestError && error.status === 401) return false;
      return failureCount < 2;
    },
    staleTime: 60_000,
  });
}

/**
 * A kolléga telefonos UGYFELRENDSZERE (TT / ProjectFlow / Salesforce / egyik sem).
 *
 * Ettol fugg, mi latszik a hivas mellett: TT-kartya es -kereses csak TT-snel.
 * Amig nem tudjuk (betoltes, regi szerver), "egyik sem" - inkabb hianyozzon egy
 * pillanatra a kartya, mint hogy olyan lassa a TT-adatot, akinek nem szabad. A
 * szerver ettol fuggetlenul is elzarja.
 */
export function useCustomerSystem(): CustomerSystem {
  return useSession().data?.customerSystem ?? 'none';
}
